// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, "#mainNav,#mainNav .v-toolbar__content,#mainNav img{transition:all .2s ease-in-out!important}.v-main__wrap{display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
